var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1231 17.8062L21.7396 9.97587L20.0533 11.1159L25.4371 18.944L27.1233 17.804L27.1231 17.8062ZM25.1051 19.2237L16.8748 14.4082L15.8375 16.1506L24.0684 20.9645L25.1053 19.2217L25.1051 19.2237ZM23.9004 21.5384L14.6731 19.0769L14.1425 21.0312L23.3707 23.4912L23.9004 21.5367V21.5384ZM23.2728 24.1775L13.7581 23.3081L13.5706 25.3237L23.0857 26.1922L23.2728 24.1775ZM29.5001 17.3337L27.8656 8L25.8543 8.34594L27.4888 17.6816L29.5001 17.3356V17.3337ZM23.0431 28.7962L13.4874 28.8007L13.4866 26.777L23.042 26.7721L23.0431 28.7962Z",
    fill: "#FF810F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6658 22.1394V30.4124H12.1325V22.1394H10.4999V32H26.2901V22.1394H24.6658Z",
    fill: "#BEBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/Social-3.bbf2f3efdfde0021efcfe6112f4922a6.svg";
export { ForwardRef as ReactComponent };